(function (module) {
    'use strict';
    function ErrorConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('error', {
                url: '/error',
                data: {
                    pageTitle: 'ERROR.PAGE_TITLE'
                },
                params: {
                    code: {squash: true, value: null}
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@error': {
                        templateUrl: '/js/authentication/error/error.html',
                        controller: 'ErrorCtrl as vm'
                    }
                },
                bodyClass: 'page--error'
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/error');

    }

    function ErrorCtrl($stateParams) {

        // TODO: Add switch statement to cater for all errors
        // Current errors: INVALID_TOKEN
        this.code = $stateParams.code;

    }

    module
        .config(ErrorConfig)
        .controller('ErrorCtrl', ErrorCtrl);

})(angular.module('rocket.components'));
